export const average = (arr) =>
	Math.round((arr.reduce((p, c) => p + c, 0) / arr.length) * 100) / 100;
